import api from '../../assets/js/api-instance'

let subscriptionHandlers = {};

export default {
	state: {
		tokens: [],
		tokenState: {},
		fixes: {},
		nrpl: "",
		filtered: {}
	},
	
	mutations: {
		/**
		 * Populate the list of tokens
		 * 
		 * @p payload token[]
		 * 
		 */
		setTokens(state, payload) {
			state.tokens = payload ? payload : [];
		},
		
		/**
		 * Set / replace a single token
		 * 
		 * @p payload token
		 * 
		 */
		setToken(state, payload) {
			console.log("setToken", payload);
			const index = state.tokens.findIndex( token => token.token_id == payload.token_id );
			console.log("setToken", index);
			if (index != -1) {
				state.tokens[index] = payload;
			} else {
				state.tokens.push(payload);
			}
		},
		
		/**
		 * Remove a token
		 */
		removeToken(state, payload) {
			const index = state.tokens.findIndex( token => token.token_id == payload );
			console.log("removeToken mutation", payload, index);
			if (index != -1) {
				// Remove also tokenState
				delete state.tokenState[payload.token_id];
				state.tokens.splice(index, 1);
			}
		},
		
		setTokenState(state, payload) {
			state.tokenState = payload
				? Object.assign({}, state.tokenState, payload)
				: {}
		},
		
		setTokenVisible(state, payload) {
			const tokenState = Object.assign({
				[payload.token_id]: {}
			}, state.tokenState);
			tokenState[payload.token_id].visible = payload.visible;
			
			state.tokenState = tokenState;
		},
		
		setTokenTracking(state, payload) {
			const tokenState = Object.assign({
				[payload.token_id]: {}
			}, state.tokenState);
			tokenState[payload.token_id].tracking = payload.tracking;
			
			state.tokenState = tokenState;
		},
		
		setTokenRecording(state, payload) {
			// Allow recording to only one token at a time
			const tokenState = Object.assign({
				[payload.token_id]: {}
			}, state.tokenState);
			
			Object.values(tokenState).forEach(token => {
				delete token.recording;
			});
			
			tokenState[payload.token_id].recording = payload.recording;
			
			state.tokenState = tokenState;
		},
		
		// This mutation can replace the two mutations
		// above. E.g.:
		// commit('setTokenVisible', { abcdef: true }) can be
		// expressed as
		// commit('setTokenAttributes', { abcdef: { visible: true } })
		setTokenAttributes(state, payload) {
			const tokenState = Object.assign({}, state.tokenState);
			
			Object.keys(payload)
			.forEach(token_id => {
				if (!tokenState.hasOwnProperty(token_id)) {
					tokenState[token_id] = Object.assign({}, payload[token_id]);
				} else {
					tokenState[token_id] = Object.assign(tokenState[token_id], payload[token_id]);
				}
			});

			state.tokenState = tokenState;
		},
		
		setTokenFixes (state, payload) {
			state.fixes = Object.assign({}, state.fixes, payload);
		},
		
		prependTokenFixes (state, payload) {
			console.log("PREPEND", payload);
			let fixes = {};
			for (const fix of payload) {
				if (!fixes[fix.token_id]) {
					fixes[fix.token_id] = [];
				}
				fixes[fix.token_id].push(fix);
			}
			console.log("FIXES", fixes);
			for (const token_id in fixes) {
				if (!state.fixes[token_id]) {
					state.fixes[token_id] = fixes[token_id];
				} else {
					state.fixes[token_id] = [...fixes[token_id], ...state.fixes[token_id]];
				}
			}
		},
		
		appendTokenFixes (state, payload) {
			let fixes = {};
			for (const fix of payload) {
				if (!fixes[fix.token_id]) {
					fixes[fix.token_id] = [];
				}
				fixes[fix.token_id].push(fix);
			}
			for (const token_id in fixes) {
				if (!state.fixes[token_id]) {
					state.fixes[token_id] = fixes[token_id];
				} else {
					state.fixes[token_id] = [...state.fixes[token_id], ...fixes[token_id]];
				}
			}
		},
		
		/**
		 * Remove fixes.
		 * 
		 * @p token_id Token from which to remove fixes
		 * @p fix_id Fix or fixes to remove
		 * 
		 * Both arguments are optional. The results are
		 * as follows:
		 * 
		 * token_id  | fix_id    | Outcome
		 * ----------|-----------|--------
		 * Not given | Not given | Remove all fixes
		 * Given     | Not given | Remove all fixes from the given token_id
		 * Not given | Given     | Remove the fix with ID fix_id irrespective of token_id
		 * Given     | Given     | Remove the fix with ID fix_id from the given token_id
		 * 
		 */
		removeTokenFixes (state, {token_id, fix_id} = {}) {
			const fixList = Array.isArray(fix_id) ? fix_id : [ fix_id ];
			if (token_id) {
				if (fix_id) {
					state.fixes[token_id] =
						state.fixes[token_id].filter( fix => !fixList.includes(fix.fix_id) );
					state.filtered[token_id] =
						state.filtered[token_id].filter( fix => !fixList.includes(fix.fix_id) );
				} else {
					delete state.fixes[token_id];
					delete state.filtered[token_id];
				}
			} else {
				if (fix_id) {
					for (const token_id in state.fixes) {
						state.fixes[token_id] =
							state.fixes[token_id].filter( fix => !fixList.includes(fix.fix_id) );
						state.filtered[token_id] =
							state.filtered[token_id].filter( fix => !fixList.includes(fix.fix_id) );
					}
				} else {
					state.fixes = {};
					state.filtered = {};
				}
			}
		},
		
		setFiltered (state, stack) {
			const filtered = {};
			if (stack) {
				for (const fix of stack.filter(fix => fix instanceof Object && fix.token_id)) {
					const token_id = fix.token_id;
					if (!filtered[token_id]) {
						filtered[token_id] = [];
					}
					filtered[token_id].push(fix);
				}
			}
			console.log("flt", filtered);
			state.filtered = filtered;
		},
		
		setNRPL (state, script) {
			state.nrpl = script;
		}
	},
	
	getters: {
		visibleTokens (state) {
			return Object.entries(state.tokenState)
			.filter(entry => entry[1] && entry[1].visible)
			.map(entry => entry[0]);
		}
	},
	
	actions: {
		initSubscriptionHandlers({state, commit, dispatch}) {
			if (!subscriptionHandlers.fixes) {
				subscriptionHandlers.fixes = (payload) => {
					if (payload) {
						if (payload.remove) {
// 							console.warn("Fix removal implemented", payload.remove);
							commit('removeTokenFixes', {fix_id: payload.remove});
						}
						if (payload.add) {
							commit('prependTokenFixes', payload.add);
						}
					}
				};
			}
			
			if (!subscriptionHandlers.tokens) {
				subscriptionHandlers.tokens = async (payload) => {
					if (payload) {
						if (payload.refresh) {
// 							console.warn("Token refresh implemented", payload.refresh);
							const token = await api.getToken(payload.refresh);
							commit('setToken', token); // Update token details
							dispatch('getFixes', {token_id: payload.refresh}); // Update token fixes
						}
						if (payload.remove) {
// 							console.warn("Token removal implemented", payload.remove);
							dispatch('removeToken', {token_id: payload.remove, noApiCall: true});
						}
						if (payload.add) {
// 							console.warn("Token addition implemented", payload.add);
							const token = await api.getToken(payload.add);
							commit('setToken', token);
							commit('setTokenVisible', {token_id: token.token_id, visible: false});
						}
					}
				}
			}
		},
		
		async fetchTokens({state, commit, rootState}) {
			const tokens =  await api.listTokens();
			commit('setTokens', tokens);
			tokens.forEach(token => {
				if (!state.tokens[token.token_id]) {
					commit('setTokenVisible', {token_id: token.token_id, visible: false});
				}
			});

			const channel = `tokens/${rootState.userData.user_id||"00000000"}`;
			await api.subscribe(channel, subscriptionHandlers.tokens);
		},
		
		async getFixes({commit, state}, payload) {
			console.log("GF", payload);
			const fixes = await api.getFixes(payload.token_id);
			const previousTokenState = state.tokenState[payload.token_id] || {};
			const tokenState = Object.assign({}, previousTokenState, {maybeMore: true});
			commit('setTokenFixes', { [payload.token_id]: fixes });
			commit('setTokenState', { [payload.token_id]: tokenState });
		},
		
		async getMoreFixes({state, commit}, payload) {
			console.log("GMF", payload);
			const token_id = payload.token_id;
			const offset = (state.fixes[token_id] && state.fixes[token_id].length) || 0;
			const limit = payload.limit || 500;
			const fixes = await api.getFixes(token_id, {offset, limit});
			
			const tokenState = Object.assign({}, state.tokenState[token_id]);
			tokenState.maybeMore = fixes.length == limit;
			commit('setTokenState', { [token_id]: tokenState });
			commit('appendTokenFixes', fixes);
		},
		
		async setTokenVisible({commit, dispatch}, data) {
			const channel = `fixes/${data.token_id}`;
			
			commit('setTokenVisible', data);
			if (data.visible) {
				await dispatch('getFixes', data);
				await api.subscribe(channel, subscriptionHandlers.fixes);
			} else {
				await api.unsubscribe(channel, subscriptionHandlers.fixes);
			}
		},
		
		/**
		 * Remove a token from the database or from the client data store
		 * 
		 * @p token_id {String} The ID of the token to remove
		 * @p noApiCall {Boolean} If truthy, do not remove from server
		 * 
		 * The `noApiCall` parameter is used to avoid a useless API request
		 * when reacting to a removal notification via websocket.
		 * 
		 */
		async removeToken({state, commit, dispatch}, payload) {
			const token_id = payload.token_id;
			
			if (!payload.noApiCall) {
				await api.removeToken(token_id);
			}
			
			commit('removeTokenFixes', token_id);
			commit('removeToken', token_id);
		},
		
		/**
		 * Remove all data from the token store
		 * 
		 * Used when the user logs out.
		 * 
		 */
		async clearTokenStore({state, commit, dispatch, rootState}) {
			commit('setTokenState');
			commit('removeTokenFixes');
			commit('setTokens');
			
			const channel = `tokens/${rootState.userData.user_id}`;
			await api.unsubscribe(channel, subscriptionHandlers.tokens);
		}
	}
};
